export const ROUTES = {
  dashboard: "/dashboard",
  tenant: (_id?: string) => "/workspace",
  tenantRuntime: (_id?: string) => "/workspace/runtime",
  tenantAgents: (_id?: string) => "/workspace/agents",
  tenantSkills: (_id?: string) => "/workspace/skills",
  tenantSkillNew: (_id?: string) => "/workspace/skills/new",
  tenantSkill: (_tenantId: string, tenantSkillId: string) =>
    `/workspace/skills/${encodeURIComponent(tenantSkillId)}`,
  platformSkillNew: (_id?: string) => "/workspace/skills/library/new",
  platformSkill: (_tenantId: string, platformSkillId: string) =>
    `/workspace/skills/library/${encodeURIComponent(platformSkillId)}`,
  tenantConversations: (_id?: string) => "/workspace/conversations",
  tenantOperatorConsole: (_id?: string) => "/workspace/operator-console",
  tenantOperatorConsoleSession: (_tenantId: string, sessionId: string) =>
    `/workspace/operator-console/${encodeURIComponent(sessionId)}`,
  tenantAutomationInbox: (_id?: string) => "/workspace/automation-inbox",
  tenantAutomationInboxDetail: (_tenantId: string, notificationId: string) =>
    `/workspace/automation-inbox/${encodeURIComponent(notificationId)}`,
  tenantOutbound: (_id?: string) => "/workspace/outbound",
  tenantAdminConversationsUsers: (_id?: string) => "/workspace/conversations/admin",
  tenantAdminConversationsUser: (_tenantId: string, userId: string) =>
    `/workspace/conversations/admin/${encodeURIComponent(userId)}`,
  tenantAgentNew: (_id?: string) => "/workspace/agents/new",
  tenantAgent: (_tenantId: string, agentId: string) =>
    `/workspace/agents/${agentId}`,
  tenantAgentPolicy: (_tenantId: string, agentId: string) =>
    `/workspace/agents/${agentId}/policy`,
  tenantPlugins: (_id?: string) => "/workspace/plugins",
  tenantPlugin: (_tenantId: string, pluginId: string) => `/workspace/plugins/${pluginId}`,
  tenantAiProviders: (_id?: string) => "/workspace/ai-providers",
  tenantChannels: (_id?: string) => "/workspace/channels",
  tenantDeployments: (_id?: string) => "/workspace/deployments",
  tenantConnectors: (_id?: string) => "/workspace/connectors",
  tenantConnectorPackages: (_id?: string) => "/workspace/connectors",
  tenantConnectorNew: (_id?: string) => "/workspace/connectors/new",
  tenantConnector: (_tenantId: string, connectorId: string) =>
    `/workspace/connectors/${connectorId}`,
  tenantConnectorInstalls: (_id?: string) => "/workspace/connector-installs",
  tenantConnectorInstallNew: (_id?: string) => "/workspace/connector-installs/new",
  tenantMcpToolsetNew: (_id?: string) => "/workspace/connector-installs/mcp/new",
  tenantConnectorInstall: (_tenantId: string, connectorId: string) =>
    `/workspace/connector-installs/${connectorId}`,
  tenantImplementations: (_id?: string) => "/workspace/implementations",
  tenantAutomations: (_id?: string) => "/workspace/automations",
  tenantAutomationNew: (_id: string, template?: string) =>
    template
      ? `/workspace/automations/new?template=${encodeURIComponent(template)}`
      : "/workspace/automations/new",
  tenantAutomation: (_tenantId: string, automationId: string) =>
    `/workspace/automations/${automationId}`,
  tenantWorkflows: (_id?: string) => "/workspace/workflows",
  tenantIdentity: (_id?: string) => "/workspace/identity",
  tenantIdentityNew: (_id?: string) => "/workspace/identity/new",
  tenantIdentityMapping: (_tenantId: string, channel: string, userId: string) =>
    `/workspace/identity/${encodeURIComponent(channel)}/${encodeURIComponent(userId)}`,
  tenantSnapshots: (_id?: string) => "/workspace/snapshots",
  tenantActivity: (_id?: string) => "/workspace/activity",
  executions: "/executions",
  execution: (id: string) => `/executions/${id}`,
  audit: "/audit",
  settings: "/settings",
} as const;
